var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-wrap flex flex-wrap flex-pack-justify"},[_c('video-player',{staticClass:"vjs-custom-skin videosa",attrs:{"options":_vm.videoConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }